export default "__VITE_ASSET__b4a38e39__"